import { useCallback } from "react";

declare global {
  interface Window {
    umami?: {
      track: (event: string, data?: Record<string, any>) => void;
    };
  }
}

export function useUmami() {
  // trackView: 手动触发页面浏览
  const trackView = useCallback(() => {
    window.umami?.track("pageview");
  }, []);

  // trackEvent: 触发自定义事件
  const trackEvent = useCallback((event: string, data?: Record<string, any>) => {
    window.umami?.track(event, data);
  }, []);

  return { trackView, trackEvent };
}
